import { useCallback } from "react";
import { useHistory } from "react-router";

import { buildUrl } from "shared/utils";

export const useProfileRoute = () => {
  const history = useHistory();

  const pushRoute = useCallback(
    (
      path: string,
      options?: {
        hash?: string;
        params?: Record<string, string>;
      }
    ) => {
      history.push(
        buildUrl(
          path,
          {
            ...options?.params,
          },
          options?.hash
        )
      );
    },
    [history]
  );

  const getPath = useCallback((path: string, options?: { hash?: string }) => {
    return buildUrl(path, {}, options?.hash);
  }, []);

  return { pushRoute, getPath };
};
